import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddVendorCommission({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    const [commissionType, setCommissionType] = useState("Percentage");
    const [commissionValue, setCommissionValue] = useState("");
    const [expiryDate, setExpiryDate] = useState("");

    const handleCommissionTypeChange = (event: SelectChangeEvent) => {
        setCommissionType(event.target.value);
    };

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Set Vendor Commission</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>                   
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                        

                            {/* Commission Value */}
                            <div className="control_group w_50">
                                <label htmlFor="commission-value">
                                    Commission %
                                </label>
                                <TextField
                                    type="number"
                                    placeholder={"0.00"}
                                    value={commissionValue}
                                    onChange={(e) =>
                                        setCommissionValue(e.target.value)
                                    }
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "commission-value" }}
                                />
                            </div>

                            {/* Expiry Date */}
                            <div className="control_group w_50">
                                <label htmlFor="commission-expiry">Expiry Date</label>
                                <TextField
                                    type="date"
                                    value={expiryDate}
                                    onChange={(e) =>
                                        setExpiryDate(e.target.value)
                                    }
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "commission-expiry" }}
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save Commission
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
